module.exports = __webpack_public_path__ + "static/flags/MC-28a0ff1555f52f1097ea665bf490648f.gif";